import React, { useState } from 'react';
import { Row, Col, Button, Form } from 'reactstrap';
import { InputDateControlled, useTranslator } from '@front-activerse/common-components';
import { hasRangeErrors, validateRange } from './helpers';
import type { Period, RangeErrors } from './types';

interface Props {
  period: Period;
  onPeriodChange: (period: Period) => void;
  onSubmit: (period: Period) => void;
}

const NO_ERRORS: RangeErrors = { details: [] };

const TrackerShoppingListSearch: React.FC<Props> = ({ period, onPeriodChange, onSubmit }) => {
  const { t } = useTranslator();
  const [errors, setErrors] = useState<RangeErrors>(NO_ERRORS);
  const [wasSubmitted, setWasSubmitted] = useState(false);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const nextErrors = validateRange(period, t);

    setWasSubmitted(true);
    setErrors(nextErrors);

    if (hasRangeErrors(nextErrors)) return;
    onSubmit(period);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    const nextPeriod = { ...period, [name]: value };

    onPeriodChange(nextPeriod);
    // Re-validate live only after the first submit, so typing does not nag up front.
    if (wasSubmitted) setErrors(validateRange(nextPeriod, t));
  };

  return (
    <div className="shopping-list-search">
      <h3 className="title-medium semi-bold text-center pt-m">
        {t('shoppingList.dateRange.title')}
      </h3>
      <Form onSubmit={handleSubmit} noValidate>
        <Row className="gx-0">
          <Col xs="6" className="pe-1">
            <div className="mb-m">
              <InputDateControlled
                name="start"
                value={period.start}
                errors={errors}
                handleChange={handleInputChange}
              />
            </div>
          </Col>
          <Col xs="6" className="ps-1">
            <div className="mb-m">
              <InputDateControlled
                name="end"
                value={period.end}
                errors={errors}
                handleChange={handleInputChange}
              />
            </div>
          </Col>
        </Row>

        <Button color="primary" className="w-100 mb-xl">
          {t('shoppingList.dateRange.button')}
        </Button>
      </Form>
      <hr className="m-0" />
    </div>
  );
};

export default TrackerShoppingListSearch;
